import { Machine, RawMachine } from "@/entities";

export const mockRawMachines = (): RawMachine[] => [
  {
    id: "0009cd3e-a57a-3e99-b0c9-b2f2d8f88335",
    name: "AVANX SANTA CRUZ",
    code: "054001600170",
    manufacturer: "CIMA",
    model: "SDM 100 M",
    ip: "127.0.0.1",
    port: "8080",
    type: "AC",
    noteCapacity: 200000,
    countryCode: "BR",
    delegationCode: "036",
    delegationName: "BR036 - BARREIRAS",
    solutionType: "CashToday",
    servicePointCount: 1,
    lastUpdate: "2024-12-26T13:07:11.270381Z",
    multiClient: false,
    clientMode: "SINGLE_CLIENT",
  },
  {
    id: "0009cd3e-a57a-3e99-b0c9-b2f2d8f88335",
    name: "AVANX SANTA CRUZ",
    code: "054001600170",
    manufacturer: "CIMA",
    model: "SDM 100 M",
    ip: "127.0.0.1",
    port: "8080",
    type: "AC",
    noteCapacity: 200000,
    countryCode: "BR",
    delegationCode: "036",
    delegationName: "BR036 - BARREIRAS",
    solutionType: "CashToday",
    servicePointCount: 1,
    lastUpdate: "2024-12-26T13:07:11.270381Z",
    multiClient: false,
    clientMode: "MULTI_CLIENT",
  },
  {
    id: "0009cd3e-a57a-3e99-b0c9-b2f2d8f88335",
    name: "AVANX SANTA CRUZ",
    code: "054001600170",
    manufacturer: "CIMA",
    model: "SDM 100 M",
    ip: "127.0.0.1",
    port: "8080",
    type: "AC",
    noteCapacity: 200000,
    countryCode: "BR",
    delegationCode: "036",
    delegationName: "BR036 - BARREIRAS",
    solutionType: "CashToday",
    servicePointCount: 1,
    lastUpdate: "2024-12-26T13:07:11.270381Z",
    multiClient: false,
    clientMode: "MULTI_CENTER",
  },
  {
    id: "0009cd3e-a57a-3e99-b0c9-b2f2d8f88335",
    name: "AVANX SANTA CRUZ",
    code: "054001600170",
    manufacturer: "CIMA",
    model: "SDM 100 M",
    ip: "127.0.0.1",
    port: "8080",
    type: "AC",
    noteCapacity: 200000,
    countryCode: "BR",
    delegationCode: "036",
    delegationName: "BR036 - BARREIRAS",
    solutionType: "CashToday",
    servicePointCount: 1,
    lastUpdate: "2024-12-26T13:07:11.270381Z",
    multiClient: false,
    clientMode: "MULTI_CLIENT",
  },
  {
    id: "0009cd3e-a57a-3e99-b0c9-b2f2d8f88335",
    name: "AVANX SANTA CRUZ",
    code: "054001600170",
    manufacturer: "CIMA",
    model: "SDM 100 M",
    ip: "127.0.0.1",
    port: "8080",
    type: "AC",
    noteCapacity: 200000,
    countryCode: "BR",
    delegationCode: "036",
    delegationName: "BR036 - BARREIRAS",
    solutionType: "CashToday",
    servicePointCount: 1,
    lastUpdate: "2024-12-26T13:07:11.270381Z",
    multiClient: false,
    clientMode: "MULTI_CENTER",
  },
  {
    id: "0009cd3e-a57a-3e99-b0c9-b2f2d8f88335",
    name: "AVANX SANTA CRUZ",
    code: "054001600170",
    manufacturer: "CIMA",
    model: "SDM 100 M",
    ip: "127.0.0.1",
    port: "8080",
    type: "AC",
    noteCapacity: 200000,
    countryCode: "BR",
    delegationCode: "036",
    delegationName: "BR036 - BARREIRAS",
    solutionType: "CashToday",
    servicePointCount: 1,
    lastUpdate: "2024-12-26T13:07:11.270381Z",
    multiClient: false,
    clientMode: "MULTI_CLIENT",
  },
  {
    id: "0009cd3e-a57a-3e99-b0c9-b2f2d8f88335",
    name: "AVANX SANTA CRUZ",
    code: "054001600170",
    manufacturer: "CIMA",
    model: "SDM 100 M",
    ip: "127.0.0.1",
    port: "8080",
    type: "AC",
    noteCapacity: 200000,
    countryCode: "BR",
    delegationCode: "036",
    delegationName: "BR036 - BARREIRAS",
    solutionType: "CashToday",
    servicePointCount: 1,
    lastUpdate: "2024-12-26T13:07:11.270381Z",
    multiClient: false,
    clientMode: "MULTI_CENTER",
  },
  {
    id: "0009cd3e-a57a-3e99-b0c9-b2f2d8f88335",
    name: "AVANX SANTA CRUZ",
    code: "054001600170",
    manufacturer: "CIMA",
    model: "SDM 100 M",
    ip: "127.0.0.1",
    port: "8080",
    type: "AC",
    noteCapacity: 200000,
    countryCode: "BR",
    delegationCode: "036",
    delegationName: "BR036 - BARREIRAS",
    solutionType: "CashToday",
    servicePointCount: 1,
    lastUpdate: "2024-12-26T13:07:11.270381Z",
    multiClient: false,
    clientMode: "SINGLE_CLIENT",
  },
];

export const mockMachines = (data: RawMachine[] = mockRawMachines()): Machine[] =>
  data.map((item) => new Machine(item));
